import { useQuery } from 'react-query';
import request from '../../../../../helpers/request';
import { queryKeysShutdowns } from '../../constants/queryKeys';

const getSavedFilters = async () => {
  return await request.get(
    `/Filter`,
    { type: 'ALERT' },
    'При загрузке сохраненных фильтров произошла ошибка'
  );
};

const useSavedFiltersQuery = (options) =>
  useQuery(queryKeysShutdowns.savedFilters(), getSavedFilters, options);

export default useSavedFiltersQuery;
